/**
 * How a colleague who has left Project A is named wherever their relationships
 * are still shown: "Oskar Lingk (left Oct 2026)", or "(left)" for somebody who
 * left before anybody recorded the day.
 */
export function formerMemberLabel(name, leftOn) {
    return `${name} (${leftOn === null ? 'left' : `left ${leftMonth(leftOn)}`})`;
}
/**
 * What a Project A member does, for deciding whether their relationships are a
 * way into a fund. `investment` (the deal team) and `platform` (talent,
 * marketing, finance, legal, operations) count; `support` (executive and team
 * assistants, office management) does not. A member with no class counts as
 * investment.
 */
export const MEMBER_ROLE_CLASSES = ['investment', 'platform', 'support'];
export const MEMBER_ROLE_CLASS_LABELS = {
    investment: 'Investment',
    platform: 'Platform / Operations',
    support: 'Support',
};
/** The short name a support colleague is labelled with: "EA", their title, or "support". */
export function supportRoleName(title) {
    const trimmed = title?.trim() ?? '';
    if (/\bexecutive assistant\b|\bea\b/i.test(trimmed))
        return 'EA';
    return trimmed === '' ? 'support' : trimmed;
}
/**
 * How a colleague whose relationships do not count as a way in is named
 * wherever those relationships still show: a former member as above, a
 * current support colleague as "Jane Doe (EA)".
 */
export function excludedMemberLabel(member) {
    return member.active
        ? `${member.name} (${supportRoleName(member.title)})`
        : formerMemberLabel(member.name, member.leftOn);
}
/** `YYYY-MM-DD` as "Oct 2026". */
export function leftMonth(day) {
    const [year, month] = day.split('-');
    return `${MONTHS[Number(month) - 1] ?? month} ${year}`;
}
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//# sourceMappingURL=formerTeam.js.map